import { Rectangle, Room } from "@mui/icons-material";
import { Button, Divider, Modal, Select } from "antd";
import { Field, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { FeatureGroup, MapContainer, TileLayer, GeoJSON } from "react-leaflet";
import { EditControl } from "react-leaflet-draw";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllActivityGroup,
  getAllProduct,
  getAllSubSector,
  getIntersection,
  getSpecifiedQuestions,
} from "../../api/crud";
import {
  productFetch,
  questionFetch,
  selectLicenseList,
  setIntersectionInitialState,
  setIntersectionLength,
  setIntersectionModalStats,
  setIntersectionResult,
  setIntersectionResultModal,
  setIntersectionStats,
  setModalStats,
  setQuestions,
} from "../../api/redux";
import IntersectionButtons from "./IntersectionButtons";
import IntersectionForms from "./IntersectionForms";
import IntersectionMap from "./IntersectionMap";
import * as Yup from "yup";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { selectPartList, townshipFetch } from "../../api/partsRedux";

const { Option } = Select;

const intersectionValidationSchema = Yup.object().shape({
  townshipId: Yup.string()
    .required("فیلد محصول الزامی است")
    .typeError("فیلد محصول الزامی است"),
});

export default (props) => {
  const state = useSelector(selectLicenseList);
  const [productId, setProductId] = useState(null);
  const [spanData, setSpanData] = useState(null);
  const [sectors, setSectors] = useState(null);
  const [fieldsErr, setFieldsErr] = useState(false);
  const [subSectors, setSubSectors] = useState(null);
  const [activityGroups, setActivityGroups] = useState(null);
  const [products, setProducts] = useState(null);
  const [mapDrawer, setMapDrawer] = useState(null);
  const [isDrawable, setIsDrawable] = useState(true);
  const [radios, setRadios] = useState({});

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(townshipFetch());
    dispatch(productFetch());
  }, []);

  const partsState = useSelector(selectPartList);

  const onClose = () => {
    dispatch(setQuestions(null));
    setRadios({});
    dispatch(setIntersectionInitialState(null));
    dispatch(setIntersectionModalStats(false));
  };

  const sectorChangeHandler = async (e, a) => {
    const params = { sectorId: a.value };
    const response = await getAllSubSector(params);
    setSubSectors(response.data.data);
  };

  return (
    <Modal
      title="محاسبه محدودیت ها"
      className="as-modal p-0"
      footer={false}
      width={"60%"}
      visible={state.intersectionModalStats}
      onCancel={onClose}
    >
      {state.intersectionInitialState && (
        <div className="d-flex flex-wrap p-1">
          <Formik
            enableReinitialize
            validationSchema={intersectionValidationSchema}
            validateOnChange={true}
            initialValues={state.intersectionInitialState || {}}
            onSubmit={async (values) => {
              dispatch(setIntersectionStats("loading"));
              dispatch(setIntersectionResultModal(true));
              setFieldsErr(false);
              let answers = [];
              const keys = Object.keys(radios);
              keys.map((el) => {
                answers.push({ id: el, questionAnswer: radios[el] });
              });
              getIntersection({
                spanData,
                productId: values?.productId,

                answers,
                limitationCategoryId: values?.limitationCategoryId,
                townshipId: values.townshipId,
              })
                .then((res) => {
                  dispatch(setIntersectionStats("idle"));

                  const allLayerCondition = res.data.data.allLayerCondition;
                  const intersects = res.data.data.intersects;

                  allLayerCondition.map((el) => {
                    el.spanData = intersects.filter(
                      (le) => le.limitationId === el.limitationId
                    );
                  });
                  onClose();
                  dispatch(setIntersectionResult(allLayerCondition));
                  dispatch(setIntersectionModalStats(false));
                })
                .catch((err) => {
                  dispatch(setIntersectionStats("failed"));
                });
              onClose();
            }}
          >
            {({ handleSubmit, setFieldValue, values, errors, touched }) => {
              return (
                <div className="d-flex flex-wrap col-12 mt-3 mb-1">
                  <div className="col-12 col-md-6">
                    <Select
                      size={"large"}
                      className="w-100 search-fields"
                      placeholder="انتخاب رده"
                      onSelect={(e, a) => {
                        setFieldValue("limitationCategoryId", e);
                      }}
                      onClear={(e) => {
                        setFieldValue("limitationCategoryId", null);
                      }}
                      direction="rtl"
                      showArrow={true}
                      value={values?.limitationCategoryId}
                      key={5}
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().match(input.toLowerCase())
                      }
                      defaultValue={0}
                    >
                      <Option className="text-right" value={0}>
                        همه رده ها
                      </Option>
                      {state.limitationCategories &&
                        state.limitationCategories.map((el) => {
                          return (
                            <Option className="text-right" value={el.id}>
                              {el.title}
                            </Option>
                          );
                        })}
                    </Select>
                  </div>
                  {/* <div className="col-12 col-md-6">
                    {state?.sectors && (
                      <Select
                        size={"large"}
                        className="w-100 search-fields"
                        placeholder="انتخاب بخش"
                        showArrow={true}
                        allowClear
                        showSearch
                        onSelect={(e, a) => {
                          setFieldValue("subSectorId", null);

                          setFieldValue("activityGroupId", null);
                          setFieldValue("productId", null);
                          setFieldValue("sectorId", e);
                          sectorChangeHandler(e, a);
                        }}
                        // allowClear
                        onClear={(e) => {
                          setFieldValue("subSectorId", null);
                          setFieldValue("sectorId", null);
                          setFieldValue("activityGroupId", null);
                          setFieldValue("productId", null);
                          setProducts(null);
                          setSubSectors(null);
                          setActivityGroups(null);
                        }}
                        direction="rtl"
                        // showArrow={true}
                        value={values?.sectorId}
                        key={5}
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .match(input.toLowerCase())
                        }
                      >
                        {state.sectors &&
                          state.sectors.map((el) => {
                            return (
                              <Option className="text-right" value={el.id}>
                                {el.title}
                              </Option>
                            );
                          })}
                      </Select>
                    )}
                  </div>
                  <div className="col-12 col-md-6">
                    {" "}
                    <Select
                      className="w-100 search-fields"
                      size="large"
                      placeholder={"انتخاب زیربخش"}
                      showArrow={true}
                      direction="rtl"
                      filterOption={(input, option) =>
                        option.children.toLowerCase().match(input.toLowerCase())
                      }
                      allowClear
                      key={6}
                      value={values?.subSectorId}
                      onSelect={(e) => {
                        setFieldValue("activityGroupId", null);
                        setFieldValue("productId", null);
                        setFieldValue("subSectorId", e);
                        getAllActivityGroup({ subSectorId: e }).then((res) => {
                          setActivityGroups(res.data.data);
                        });
                      }}
                      onClear={(e) => {
                        setFieldValue("subSectorId", null);
                        setFieldValue("activityGroupId", null);
                        setFieldValue("productId", null);
                        setActivityGroups(null);
                        setProducts(null);
                      }}
                    >
                      {subSectors &&
                        subSectors.map((el) => {
                          return (
                            <Option className="text-right" value={el.id}>
                              {el.title}
                            </Option>
                          );
                        })}
                    </Select>
                  </div>
                  <div className="col-12 col-md-6">
                    {" "}
                    <Select
                      className="w-100 search-fields"
                      size="large"
                      placeholder={"انتخاب گروه فعالیت"}
                      // showArrow={true}
                      direction="rtl"
                      allowClear
                      filterOption={(input, option) =>
                        option.children.toLowerCase().match(input.toLowerCase())
                      }
                      key={6}
                      value={values?.activityGroupId}
                      onSelect={(e) => {
                        setFieldValue("productId", null);
                        setFieldValue("activityGroupId", e);
                        const params = { id: e };
                        dispatch(questionFetch(params));
                        getAllProduct({ activityGroupId: e }).then((res) => {
                          setProducts(res.data.data);
                        });
                      }}
                      onClear={(e) => {
                        setProducts(null);
                        setFieldValue("activityGroupId", null);
                        setFieldValue("productId", null);
                      }}
                    >
                      {activityGroups &&
                        activityGroups.map((el) => {
                          return (
                            <Option className="text-right" value={el.id}>
                              {el.title}
                            </Option>
                          );
                        })}
                    </Select>
                  </div> */}
                  {state?.products && (
                    <div className="col-12 col-md-6">
                      {" "}
                      <Select
                        className="w-100 search-fields"
                        size="large"
                        placeholder={"انتخاب محصول بر اساس عنوان یا کد آیسیک"}
                        showArrow
                        direction="rtl"
                        allowClear
                        showSearch
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .match(input.toLowerCase()) ||
                          option.isicCode
                            .toLowerCase()
                            .match(input.toLowerCase())
                        }
                        key={6}
                        value={values?.productId}
                        onSelect={(e, a) => {
                          setFieldValue("activityGroupId", e);
                          const params = { id: a?.productId };
                          dispatch(questionFetch(params));
                        }}
                        onClear={(e) => {
                          setFieldValue("activityGroupId", null);
                        }}
                      >
                        {state?.products &&
                          state?.products.map((el) => {
                            console.log("hioooooo", el);
                            return (
                              <Option
                                className="text-right"
                                productId={el?.id}
                                isicCode={el?.IsicCode?.isicCode}
                                value={el.ActivityGroup.id}
                              >
                                {el.title}
                              </Option>
                            );
                          })}
                      </Select>
                    </div>
                  )}
                  <div className="col-12 col-md-6">
                    {" "}
                    <Select
                      className="w-100 search-fields"
                      size="large"
                      placeholder={"انتخاب شهرستان"}
                      showArrow={true}
                      direction="rtl"
                      allowClear
                      key={6}
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().match(input.toLowerCase())
                      }
                      value={values?.townshipId}
                      onSelect={(e) => {
                        setFieldValue("townshipId", e);
                      }}
                      onClear={(e) => {
                        setFieldValue("townshipId", null);
                      }}
                    >
                      {partsState?.townships &&
                        partsState?.townships.map((el) => {
                          return (
                            <Option className="text-right" value={el.id}>
                              {el.title}
                            </Option>
                          );
                        })}
                    </Select>
                  </div>
                  <div className="col-12 im-map">
                    <MapContainer
                      maxZoom={15}
                      bounds={
                        state?.province?.spanData?.type === "MultiPolygon"
                          ? state.province?.spanData?.coordinates[0][0].map(
                              (el) => {
                                return [el[1], el[0]];
                              }
                            )
                          : state.province?.spanData?.coordinates[0].map(
                              (el) => {
                                return [el[1], el[0]];
                              }
                            )
                      }
                    >
                      <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        key={1}
                      />

                      <FeatureGroup>
                        <EditControl
                          position="topright"
                          onCreated={async (data) => {
                            setIsDrawable(false);
                            if (data.layerType === "marker") {
                              setSpanData({
                                type: "Point",
                                coordinates: [
                                  data.layer._latlng.lat,
                                  data.layer._latlng.lng,
                                ],
                              });
                            } else if (data.layerType === "polygon") {
                              const polyArr =
                                await data.layer.editing.latlngs[0][0].map(
                                  (el) => {
                                    return [el.lng, el.lat];
                                  }
                                );
                              polyArr[polyArr.length] = polyArr[0];
                              setSpanData({
                                type: "Polygon",
                                coordinates: [polyArr],
                              });
                            }
                          }}
                          edit={{ edit: false }}
                          onDeleted={() => [setIsDrawable(true)]}
                          onMounted={(drawControl) => {
                            if (!mapDrawer) {
                              setMapDrawer(drawControl._toolbars.draw._modes);
                            }
                          }}
                          draw={{
                            rectangle: false,
                            circle: false,
                            circlemarker: false,
                            marker: isDrawable,
                            polygon: isDrawable,
                            polyline: false,
                          }}
                        />
                        {state.province && (
                          <GeoJSON data={state.province?.spanData} />
                        )}
                      </FeatureGroup>
                    </MapContainer>
                  </div>
                  <div className="col-12 im-button-div d-flex p-0">
                    <div className="col-12 col-md-6">
                      <Button
                        className="h-100 w-100 im-button d-flex justify-content-center align-items-center"
                        onClick={() => {
                          mapDrawer.polygon.handler.enable();
                        }}
                        disabled={!isDrawable}
                      >
                        <Rectangle />
                        <h6 className="my-auto">چند ضلعی</h6>
                      </Button>
                    </div>
                    <div className="d-flex col-12 col-md-6">
                      <Button
                        className="h-100 w-100 im-button d-flex justify-content-center align-items-center"
                        onClick={() => {
                          mapDrawer.marker.handler.enable();
                        }}
                        disabled={!isDrawable}
                      >
                        <Room />
                        <h6 className="my-auto">مارکر</h6>
                      </Button>
                    </div>
                  </div>
                  {state.questions && (
                    <div className="d-flex flex-wrap mt-4 mb-1">
                      {state.questions.map((el) => (
                        <div
                          className="d-flex flex-wrap col-12 my-1"
                          style={{ marginLeft: "10px" }}
                        >
                          <h6 className="my-auto ml-3">{el?.title}</h6>
                          <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue={radios[el?.id]}
                            name="radio-buttons-group"
                            className="d-flex flex-wrap"
                            onChange={(e) => {
                              const copy = radios;
                              copy[el?.id] = e.target.value;
                              setRadios(copy);
                            }}
                          >
                            <FormControlLabel
                              value="0"
                              control={<Radio />}
                              label="خیر"
                            />
                            <FormControlLabel
                              value="1"
                              control={<Radio />}
                              label="بله"
                            />
                          </RadioGroup>
                        </div>
                      ))}
                    </div>
                  )}
                  {/* {errors.productId && (
                    <div className="col-12 text-right mt-4">
                      <h6 className="my-auto text-danger">
                        {errors.productId}
                      </h6>
                    </div>
                  )} */}
                  {fieldsErr && (
                    <div className="col-12 text-right mt-2">
                      <h6 className="my-auto text-danger">
                        لطفا به تمامی سوالات جواب دهید و محدوده را رسم کنید
                      </h6>
                    </div>
                  )}
                  {errors?.townshipId && (
                    <div className="col-12 text-right mt-2">
                      <h6 className="my-auto text-danger">
                        فیلد شهرستان الزامیست
                      </h6>
                    </div>
                  )}
                  {!values?.activityGroupId && (
                    <div className="col-12 text-right mt-2">
                      <h6 className="my-auto text-danger">
                        فیلد محصول الزامیست
                      </h6>
                    </div>
                  )}
                  <Divider className="col-12" />
                  <div className="col-12 im-button-div d-flex p-0 mb-2 justify-content-end">
                    <div className="col-12 col-md-6">
                      <Button
                        className="h-100 w-100 im-button d-flex justify-content-center align-items-center"
                        onClick={() => {
                          dispatch(setIntersectionModalStats(false));
                        }}
                      >
                        <h6 className="my-auto">انصراف</h6>
                      </Button>
                    </div>
                    <div className="d-flex col-12 col-md-6">
                      <Button
                        className="h-100 w-100 im-button d-flex justify-content-center align-items-center"
                        onClick={() => {
                          const keys = Object.keys(radios);
                          if (
                            (state.questions &&
                              state.questions.length !== keys.length &&
                              !values?.activityGroupId) ||
                            !spanData
                          ) {
                            setFieldsErr(true);
                          } else {
                            handleSubmit();
                          }
                        }}
                      >
                        <h6 className="my-auto">محاسبه</h6>
                      </Button>
                    </div>
                  </div>
                </div>
              );
            }}
          </Formik>
        </div>
      )}
    </Modal>
  );
};
